var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.5C19.8978 22.5 20.2794 22.342 20.5607 22.0607C20.842 21.7794 21 21.3978 21 21C21 20.6022 20.842 20.2206 20.5607 19.9393C20.2794 19.658 19.8978 19.5 19.5 19.5C19.1022 19.5 18.7206 19.658 18.4393 19.9393C18.158 20.2206 18 20.6022 18 21C18 21.3978 18.158 21.7794 18.4393 22.0607C18.7206 22.342 19.1022 22.5 19.5 22.5ZM9.5 22.5C9.89782 22.5 10.2794 22.342 10.5607 22.0607C10.842 21.7794 11 21.3978 11 21C11 20.6022 10.842 20.2206 10.5607 19.9393C10.2794 19.658 9.89782 19.5 9.5 19.5C9.10218 19.5 8.72064 19.658 8.43934 19.9393C8.15804 20.2206 8 20.6022 8 21C8 21.3978 8.15804 21.7794 8.43934 22.0607C8.72064 22.342 9.10218 22.5 9.5 22.5Z",
    fill: "#29292E",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.5H22L20 15.5M5 4.5L7 15.5H20M5 4.5C4.833 3.833 4 2.5 2 2.5M20 15.5H5.23C3.446 15.5 2.5 16.281 2.5 17.5C2.5 18.719 3.446 19.5 5.23 19.5H19.5",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirCart);
export default __webpack_public_path__ + "static/media/iconoir_cart.128abc4eb2a9acd19c36053103581e3e.svg";
export { ForwardRef as ReactComponent };